/*发薪查询 */
import { $http, buildHeaders } from "./index";

//获取发薪单列表
export const salaryrecord_list = (params) => {
  return $http.get("/admin/SalaryRecord/index", { params });
};

//获取发薪单详情
export const salaryrecord_detail = (id) => {
  return $http.get("/admin/SalaryRecord/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取发薪单明细
export const salaryrecord_record = (params) => {
  return $http.get("/admin/SalaryRecord/detail", { params });
};

//撤回发放
export const salaryrecord_cancelpay = (id) => {
  return $http.post(
    "/admin/SalaryRecord/cancelPay",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取发薪单操作日志
export const salaryrecord_log = (params) => {
  return $http.get("/admin/SalaryRecord/log", { params });
};

//上传薪酬发放电子回单文件
export const salaryrecord_log_upload = (data) => {
  return $http.post("/admin/SalaryRecord/uploadSftpFile", data, {
    headers: buildHeaders(3),
  });
};

//下载发薪单电子回单
export const salaryrecord_log_donwload = (params) => {
  return $http.get("/admin/SalaryRecord/downloadSftpFile", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//删除电子回单
export const salaryrecord_delsftpfile = (data) => {
  return $http.post("/admin/SalaryRecord/delSftpFile", data, {
    headers: buildHeaders(3),
  });
};


//导出
export const salaryrecord_log_export = (params) => {
  return $http.get("/admin/SalaryRecord/logExport", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
